import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { RiMailLine } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import nema_logo from '../assets/images/nema_logo.svg'
import { useLogoutMutation } from '../redux/api/authApi'
import baseApi from '../redux/api/baseApi'
import { logOut } from '../redux/slice/authSlice'
import './formheader.css'
import styles from './Header.module.css'

const menuItems = [
  { type: 'link', label: 'Home', path: '/' },
  {
    type: 'dropdown',
    label: 'Scan',
    items: [
      { type: 'link', label: 'EEG Scan', path: '/eeg-scan' },
      { type: 'link', label: 'Book a Scan', path: '/book-now' },
    ],
  },
  {
    type: 'dropdown',
    label: 'Services',
    sections: [
      {
        title: 'Solutions',
        items: [
          { type: 'link', label: 'For Hospital | Clincs', path: '/hospital' },
          { type: 'link', label: 'For Schools', path: '/individual' },
          {
            type: 'link',
            label: 'For Colleges & Corporates',
            path: '/corporate',
          },
        ],
      },
      {
        title: 'Programs',
        items: [
          { type: 'link', label: 'Skill Readiness', path: '/vocational' },
          {
            type: 'link',
            label: 'Parent Training',
            path: '/parent-cognition-training',
          },
        ],
      },
      {
        title: 'Special Needs',
        items: [
          {
            type: 'link',
            label: 'WellBeing Services',
            path: '/wellbeing-services',
          },
        ],
      },
    ],
  },
  {
    type: 'dropdown',
    label: 'Research',
    sections: [
      {
        title: 'Knowledge Hub',
        items: [
          { type: 'link', label: 'Research Papers', path: '/research-papers' },
          { type: 'link', label: 'FAQ', path: '/faq' },
          { type: 'link', label: 'Characters', path: '/characters' },
        ],
      },
      {
        title: 'Assessments',
        items: [
          { type: 'link', label: 'ADHD', path: '/ADHD' },
          { type: 'link', label: 'Dyslexia', path: '/dyslexia' },
          { type: 'link', label: 'Dementia', path: '/dementia' },
        ],
      },
    ],
  },
  { type: 'link', label: 'About Us', path: '/about-us' },
]

const Header = () => {
  const [logout] = useLogoutMutation()

  const { user, userToken } = useSelector((state) => state.auth)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogout = async () => {
    try {
      await logout({ userToken }).unwrap()
      dispatch(logOut())
      dispatch(baseApi.util.resetApiState())
      navigate('/login')
    } catch (error) {
      console.log(error)
    }
  }

  const renderDropdownContent = (item) => {
    if (item.sections) {
      return item.sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className={styles.dropdownSection}>
          <NavDropdown.Header className={styles.dropdownHeader}>{section.title}</NavDropdown.Header>
          {section.items.map((dropItem, idx) => (
            <NavDropdown.Item key={`section-${sectionIndex}-${idx}`} href={`https://nemaai.com${dropItem.path}`} className={styles.dropdownItem}>
              {dropItem.label}
            </NavDropdown.Item>
          ))}
        </div>
      ))
    }

    return (
      <div className={styles.dropdownSection}>
        {item.items.map((dropItem, idx) => (
          <NavDropdown.Item key={`item-${idx}`} href={`https://nemaai.com${dropItem.path}`} className={styles.dropdownItem}>
            {dropItem.label}
          </NavDropdown.Item>
        ))}
      </div>
    )
  }

  return (
    <div className='navbar-area'>
      <div className='main-navbar'>
        <Container fluid>
          <Navbar collapseOnSelect expand='lg'>
            <Navbar.Brand href='/'>
              <img src={nema_logo} className='black-logo ' alt='brand-logo' style={{ mixBlendMode: 'darken' }} width={180} />
            </Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse>
              <Nav className='ms-lg-4'>
                {menuItems.map((item, index) =>
                  item.type === 'link' ? (
                    <Nav.Item key={index}>
                      <Nav.Link href={`https://nemaai.com${item.path}`}>{item.label}</Nav.Link>
                    </Nav.Item>
                  ) : (
                    <NavDropdown key={index} title={item.label} id={item.label} align='center'>
                      {renderDropdownContent(item)}
                    </NavDropdown>
                  )
                )}
              </Nav>
            </Navbar.Collapse>
            <div className='d-none d-lg-flex others-options d-flex align-items-center'>
              <div className='option-item'>
                <div className='call-info'>
                  <i className='ri-mail-line'>
                    <RiMailLine className='text-black' />
                  </i>
                  <a href='mailto:support@nemaai.com' className='d-none d-xl-inline'>
                    support@nemaai.com
                  </a>
                </div>
              </div>
              {user ? (
                <div className='option-item'>
                  <button className='default-btn border-0 px-4 py-2' onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              ) : null}
            </div>
          </Navbar>
        </Container>
      </div>
    </div>
  )
}
export default Header
